var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChildPlay = function SvgChildPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m22.682 11.687-2.121-2.121a4.47 4.47 0 0 0-3.182-1.319h-5.8a1.51 1.51 0 0 1-1.287-.728L8.915 5.225a1.5 1.5 0 0 0-2.572 1.544l1.375 2.3a4.53 4.53 0 0 0 3.86 2.182h1.863l-.477 3h-2.335a4.48 4.48 0 0 0-4.179 2.825l-.75 1.865a1.5 1.5 0 0 0 2.79 1.113l.746-1.863a1.49 1.49 0 0 1 1.393-.944h1.857l-.129.809a4.5 4.5 0 0 0 .689 3.272l.835 1.251a1.5 1.5 0 0 0 2.5-1.664l-.834-1.249a1.52 1.52 0 0 1-.227-1.115l1.163-7.3h.9a1.5 1.5 0 0 1 1.06.44l2.122 2.121a1.5 1.5 0 0 0 2.121-2.121z"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 15.504,
    cy: 3.372,
    r: 2.625
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 3.129,
    cy: 13.497,
    r: 2.25
  }))));
};
export default SvgChildPlay;